module.exports = __webpack_public_path__ + "img/die-2.db625e74.svg";